


















































import Vue from "vue";
import CreateCustomApp from "@/components/PrjAppCom/CreateCustomApp.vue";
import CreateTemApp from "@/components/PrjAppCom/CreateTemApp.vue";
import Create from "@/components/PrjAppCom/CreateApp.vue";
import AppInfo from "@/components/PrjAppCom/AppInfo.vue";
import { eventBus } from "@/utils/event";

import { kind } from "../components/PrjAppCom/transform";
import TableList from "@/components/PrjAppCom/TableList.vue";

export default Vue.extend({
  name: "PrjAppCom",
  components: { CreateCustomApp, CreateTemApp, Create, AppInfo, TableList },
  props: { projectId: { type: String }, appCode: { type: String } },
  data() {
    return {
      activeTab: "tab2",
      tabs: [
        {
          label: "无状态组件",
          name: "tab2"
        },
        {
          label: "有状态组件",
          name: "tab1"
        }
      ]
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     eventBus.$emit("setBeard", {
  //       name: "组件列表",
  //       callback: () => {
  //         vm.$router.push({ name: "PrjAppList" });
  //       }
  //     });
  //   });
  // },
  methods: {
    afterEdit(kind: kind) {
      if (kind === "Deployment") {
        this.activeTab = "tab2";
      } else {
        this.activeTab = "tab1";
      }
      this.getData(kind);
    },
    getData(kind: kind) {
      if (!kind) {
        if (this.activeTab === "tab1") {
          this.$store.dispatch(`PrjAppCom/StatefulSet/clear`);
          this.$store.dispatch(`PrjAppCom/StatefulSet/getData`);
        } else {
          this.$store.dispatch(`PrjAppCom/Deployment/clear`);
          this.$store.dispatch(`PrjAppCom/Deployment/getData`);
        }
      } else {
        this.$store.dispatch(`PrjAppCom/${kind}/clear`);
        this.$store.dispatch(`PrjAppCom/${kind}/getData`);
      }
    },
    create(data: any, type: kind) {
      if (!data) {
        (this.$refs.create as any).show();
      } else {
        data.kind = type;
        this.createCustom(data);
      }
    },
    createCustom(data: any) {
      (this.$refs.createCustom as any)?.show(data);
    },
    createTem(data: any) {
      (this.$refs.createTem as any)?.show(data);
    },
    showAppInfo(data: any, type: string) {
      eventBus.$emit("setBeard", {
        name: "概览",
        callback: () => {
          (this.$refs.appInfo as any).close();
        }
      });
      (this.$refs.appInfo as any).show(data, type);
    }
  }
});
